<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton
                btnTitle="List"
                :showBtn="true"
                :showAddNew="false"
                title="Update Quotation"
                @onClickCloseButton="onClickCloseButton"
            />
        </div>

        <div class="row p-1">
            <div class="col-md-3">
                <label class="form-label">Order Date</label>
                <input
                    class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                    tabindex="1"
                    type="date"
                    placeholder=""
                    v-model="formData.date"
                >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                <label for="colFormLabel" class="form-label"> Customer Name </label>
                <v-select
                    placeholder="Select Customer"
                    v-model="contactProfile"
                    :api-service="fetchContactProfiles"
                    disabled
                />
            </div>

            <div class="col-md-3">
                <label class="form-label"> Project </label>
                <v-select
                    placeholder="Select Customer"
                    v-model="project"
                    :api-service="fetchProjects"
                    disabled
                />
            </div>

            <div class="col-md-3">
                <label class="form-label"> Business Unit </label>
                <v-select
                    placeholder="Select Business"
                    v-model="formData.business_id"
                    :options="businessList"
                    label="name"
                    :reduce="name => name.id"
                />
            </div>

            <div class="col-md-3">
                <label class="form-label"> Deal No </label>
                <input
                    class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                    tabindex="1"
                    type="text"
                    placeholder=""
                    v-model="formData.deal_no"
                    readonly
                >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                <label for="colFormLabel" class="form-label"> Client Owner </label>
                <v-select
                    placeholder="Select Customer"
                    v-model="clientOwner"
                    :api-service="fetchContactProfiles"
                    disabled
                />
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                <label for="colFormLabel" class="form-label"> Sales Person </label>
                <v-select
                    placeholder="Select Customer"
                    v-model="salesPerson"
                    :api-service="fetchContactProfiles"
                    disabled
                />
            </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3">
            <label for="colFormLabel" class="form-label"> Sales Quotation Type </label>
            <v-select
                placeholder="Select Quotation Type"
                :options="quotationTypeList"
                v-model="formData.quotation_type_note_master_id"
                :reduce="option => option.id"
                label="name"
            />
          </div>

            <div class="col-md-3">
                <label class="form-label"> Validate Till Date </label>
                <input
                    class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                    tabindex="1"
                    type="date"
                    placeholder=""
                    v-model="formData.expiry_date"
                >
            </div>
        </div>

        <div>
            <EditItem 
                v-if="loadComponent"
                v-for="(data, index) in formData.item_details"
                :key="data.id"
                :index="index"
                :data="data"
                :vatRate="vatRate"
                :isEdit="true"
                @onClose="removeBill"
            />
        </div>

        
        <div class="px-2 mt-2">
            <button @click="addNewBill" class="btn btn-primary">Add line</button>
        </div>

        <div class="px-2">
            <div class="row justify-content-end">
                <div class="col-12 col-sm-3">
                    <div class="row">
                        <div class="col-12">
                            <div class="mb-1 row">
                                <div class="col-sm-4">
                                    <label class="col-form-label" for="first-name">Sub total</label>
                                </div>
                                <div class="col-sm-8">
                                    <input
                                        v-model="subTotal"
                                        readonly
                                        type="text"
                                        class="form-control text-right"
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="mb-1 row">
                                <div class="col-sm-4">
                                    <label class="col-form-label" for="first-name">VAT</label>
                                </div>
                                <div class="col-sm-8">
                                    <input
                                        v-model="totalVAT"
                                        readonly
                                        type="text"
                                        class="form-control text-right"
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="mb-1 row">
                                <div class="col-sm-4">
                                    <label class="col-form-label" for="first-name">Total</label>
                                </div>
                                <div class="col-sm-8">
                                    <input
                                        v-model="total"
                                        readonly
                                        type="text"
                                        class="form-control text-right"
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="mb-1 row">
                                <div class="col-sm-4">
                                    <label class="col-form-label" for="first-name">Discount / Round up Adj</label>
                                </div>
                                <div class="col-sm-8">
                                    <input
                                        v-model.trim="adjustmentDiscount"
                                        type="number"
                                        class="form-control form-control-sm discount-adj ml-auto text-right"
                                        placeholder="amount" :min="0"
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="mb-1 row">
                                <div class="col-sm-4">
                                    <label class="col-form-label" for="first-name">Net Bill</label>
                                </div>
                                <div class="col-sm-8">
                                    <input
                                        v-model.trim="grandTotal"
                                        type="number" class="form-control form-control-sm discount-adj ml-auto text-right"
                                        placeholder="amount" :min="0"
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 px-2">
            <div class="mb-1">
                <label class="form-label" for="description"> Terms And Conditions </label>
                <vField
                    as="textarea"
                    name="description"
                    type="number"
                    class="form-control"
                    v-model="formData.description"
                />
            </div>
        </div>

        <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1 px-2">
            <label class="form-label">Attachment</label>
            <BlobFileViewer :attachments="formData.attachments" />
            <FileUpload
                :is-drag-active="true"
                button-text="Upload Documents"
                v-model="formData.attachments"
            >
            </FileUpload>
        </div>

        <div class="pb-5 px-2 mt-4">
            <div class="d-flex flex-wrap gap-1 gy-2">
                <button :disabled="saveButtonLoader" @click="handleSubmit(true)" class="btn btn-primary">Update</button>
                <button @click="onClickCloseButton" class="btn btn-outline-secondary">Cancel</button>
            </div>
        </div>
    </div>

    <Loader v-if="loading"/>
</template>

<script setup>
import { ref, onMounted, computed, inject } from 'vue';
import TitleButton from '@/components/atom/TitleButton';
import handleContact from '@/services/modules/contact';
import handleProjects from "@/services/modules/procurement/project";
import handleCBusinesses from '@/services/modules/businesses';
import EditItem from '@/components/molecule/company/admin/quotation/EditItem.vue';
import handleAdmin from '@/services/modules/admin/admin';
import Loader from "@/components/atom/LoaderComponent.vue";
import FileUpload from "@/components/atom/FileUpload";
import BlobFileViewer from "@/components/atom/BlobFileViewer";
import { useRouter, useRoute } from 'vue-router';
import { vatRate } from '@/data/inventory.js'
import handleHospital from '@/services/modules/hospital';

const { fetchContactProfiles } = handleContact();
const { fetchProjects } = handleProjects();
const { fetchBusinessList } = handleCBusinesses();
const { updateQuotation, fetchQuotationById, fetchPipelineById, formatFormData, handleAttachments } = handleAdmin();
const { fetchNoteMasterList } = handleHospital();

const router = useRouter();
const route = useRoute();

const contactProfile = ref(null);
const project = ref(null);
const businessList = ref([]);
const clientOwner = ref(null);
const salesPerson = ref(null);
const quotationTypeList = ref([]);
const adjustmentDiscount = ref(0);
const saveButtonLoader=ref(false);
const loading = ref(false);
const showSuccess = inject('showSuccess');
const showError = inject('showError');
const loadComponent = ref(false);

const formData = ref({
    date: new Date().toISOString().split('T')[0],
    contact_profile_id: null,
    referrer_id: null,
    sales_person_id: null,
    project_id: null,
    quotation_type_note_master_id: null,
    business_id: null,
    deal_no: null,
    expiry_date: new Date().toISOString().split('T')[0],
    adjustment_amount: null,
    has_item_detail: 1,
    attachments: [],
    item_details: [
        {
            product_id: null,
            quantity: 1,
            free_quantity: 0,
            rate: '',
            vat: 0,
            vat_amount: 0,
            description: "",
            discount_amount: 0,
            offer_discount: 0,
            discount_percent: 0,
        }
    ],
});

const companyId = computed(() => {
    return route.params.companyId
})

const dealId = computed(() => {
    return route.query.dealId
});

const subTotal = computed(() => {
    let total = 0;

    formData.value.item_details.forEach(item => {
        const qty = parseFloat(item.quantity) || 0;
        const rate = parseFloat(item.rate) || 0;
        const discount = parseFloat(item.discount_amount) || 0;
        const offerDiscount = parseFloat(item.offer_discount) || 0;

        total += (qty * rate) - discount - offerDiscount;
    });

    return total.toFixed(4);
});

const totalVAT = computed(() => {
    let vat = 0
    formData.value.item_details.map(item => {
        if(item.vat_amount) {
            vat += parseFloat(item.vat_amount)
        }
    })

    return vat.toFixed(2)
})

const total = computed(() => {
    return (parseFloat(subTotal.value) + parseFloat(totalVAT.value)).toFixed(4);
})

const grandTotal = computed(() => {
    return ((parseFloat(total.value) - adjustmentDiscount.value).toFixed(2));
})

//Methods:
const handleSubmit = async () => {
    saveButtonLoader.value = true;
    formData.value.company_id = route.params.companyId;
    formData.value.adjustment_amount = adjustmentDiscount.value;
    delete formData.value.quotation_generals;
    formData.value.has_item_detail = 1;

    if (!validateItems()) {
        saveButtonLoader.value = false;
        return;
    }

    if(contactProfile.value) {
        formData.value.contact_profile_id = contactProfile.value.id;
    }
    
    if(clientOwner.value) {
        formData.value.referrer_id = clientOwner.value.id;
    }

    if(salesPerson.value) {
        formData.value.sales_person_id = salesPerson.value.id;
    }
    
    if(project.value) {
        formData.value.project_id = project.value.id;
    }

    const payload = formatFormData(formData.value);
    if (formData.value.attachments && formData.value.attachments.length) {
        handleAttachments(payload, formData.value.attachments);
    }

    try {
        const res = await updateQuotation(route.params.quotationId, payload);
        if (!res.status) {
            saveButtonLoader.value = false;
            return showError(res.message);
        }
        showSuccess(res.message);
        onClickCloseButton();
        saveButtonLoader.value = false;
    } catch (err) {
        console.error(err);
    }
}

const addNewBill = () => {
    const newItem = {
        product_id: null,
        quantity: 1,
        rate: '',
        vat: 0,
        vat_amount: 0,
        description: '',
        discount_amount: 0,
        offer_discount: 0,
        discount_percent: 0,
        business_id: null,
        project_id: null,
        cost_centre_id: null
    }
    formData.value.item_details.push(newItem)
}

const validateItems = () => {
  if (!formData.value.item_details || formData.value.item_details.length === 0) {
    showError("At least one item is required.");
    return false;
  }

  const invalidItem = formData.value.item_details.find(
    (item) => !item.rate || Number(item.rate) <= 0
  );

  if (invalidItem) {
    showError("Rate must be greater than 0");
    return false;
  }

  return true;
};

const removeBill = (index) => {
    formData.value.item_details.splice(index, 1)
}

const onClickCloseButton = () => {
     if (route.query.is_summary == 1){
       router.push({
         name: 'sale-pipeline-quotation',
         params: route.params,
         query: route.query
       })

       return
     }

    router.push({
      name: 'edit-deal',
      params: {
        ...route.params,
        salePipelineId: dealId.value,
      },
      query: {
        ...route.query,
        tab: 'quotation',
      }
    })
}

const setInititalData = (data) => {
    contactProfile.value = {
        id: data.contact_profile_id,
        name: data.contact_profile_name
    }

    if(data.project_id) {
        project.value = {
            id: data.project_id,
            name: data.project_name
        }
    }

    if(data.referrer_id) {
        clientOwner.value = {
            id: data.referrer_id,
            name: data.referrer_name
        }
    }

    if(data.sales_person_id) {
        salesPerson.value = {
            id: data.sales_person_id,
            name: data.sales_person_name
        }
    }
    loadComponent.value = true;
}

const processDealData = (data) => {
    formData.value.deal_no = data.deal_number;
    formData.value.deal_id = data.id;
    contactProfile.value = {
        id: data.contact_profile_id,
        label: data.contact_profile_name
    }

    project.value = {
        id: data.project_master_id,
        label: data.project_name
    }

    clientOwner.value = {
        id: data.deal_owner_id,
        label: data.deal_owner_name
    }

    salesPerson.value = {
        id: data.deal_assign_id,
        label: data.deal_assign_name
    }
}

const getNoteMasterData = async () => {
  const query = `?company_id=${route.params.companyId}&note_type=quotation_type`;
  quotationTypeList.value = [];
  try {
    const res = await fetchNoteMasterList(query);
    if (!res.status) {
      return showError(res.message);
    }
    quotationTypeList.value = res.data.data;
  } catch (err) {
    console.error(err);
  }
};

onMounted(() => {
    loading.value = true;
    const companyQuery = `?company_id=${companyId.value}`;
    const quotationQuery = `?company_id=${companyId.value}&is_quotation=true`;
    const quotationId = route.params.quotationId;
    let  dealIdValue = dealId.value;
    const businessRes = fetchBusinessList(companyQuery);
    const quotationRes = fetchQuotationById(quotationId, quotationQuery);

    Promise.all([
        quotationRes.then(res=> {
            if(! res.data) return 
            formData.value = res.data;
            formData.value.item_details = res.data.quotation_generals.map(item => ({
                ...item,
                rate: item.rate || 0
            }));
            adjustmentDiscount.value = res.data.adjustment_amount;
            setInititalData(res.data);
            if (route.query.is_summary == 1){
              dealIdValue = res.data.deal_id;
            }
        }),
        businessRes.then(res=> {
            if(res.data) businessList.value = res.data
        }),
        getNoteMasterData()
    ]).then(() => {
        const dealInfoRes = fetchPipelineById(dealIdValue, companyQuery);
        dealInfoRes.then(res => {
          if (res.status) {
            processDealData(res.data);
          }
        })
        loading.value = false;
    })
})
</script>